import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';

import LeadAPI from '../../api/LeadAPI';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import Display from '../../util/Display';
import Util from '../../util/Util';
import ApiUiController from '../../controller/ApiUiController';

import './LeadPreview.css';

class LeadHistory extends React.Component {

  constructor(props) {
    super(props);
    this.user = reactLocalStorage.getObject(Const.LoggedInUser);
    const models = reactLocalStorage.getObject(Const.Model);
    this.fields = models.lead.fields;
    this.id = parseInt(props.match.params.leadId);
    this.state = { inApiCall: true, data: [] };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(this.id !== parseInt(props.match.params.leadId)) {
      this.setState({ ...this.state, inApiCall: true });
      LeadAPI.history(this.id, this.onReceived, this.onFail);
    }
  }

  componentDidMount() { if(this.id !== 0) { LeadAPI.history(this.id, this.onReceived, this.onFail); } }

 onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  
  onReceived = leads => {
    new Promise(resolve => {
      const tmp = leads.map(lead => {return { ...lead, updated_date: Util.serverStringDateTimeToDate(lead.updated_date)}})
        .sort((l, r) => l.updated_date.getTime() < r.updated_date.getTime() ? 1 : -1 );

      const data = [];
      for(let i = 0; i < tmp.length; i++) {
        const no = i + 1;
        const user = Display.FieldValue(tmp[i], 'updated_by', this.fields);
        const date = Display.FieldValue(tmp[i], 'updated_date', this.fields);
        let updatedInfo = '';
        if(no ===  tmp.length) {
          updatedInfo = 'Added On this Date';
        } else {
          const fields = Object.keys(this.fields);
          for(let j = 0; j < fields.length; j++) {
            if(fields[j] === 'updated_date') {
              continue;
            }
            const newVal = Display.FieldValue(tmp[i], fields[j], this.fields);
            const oldVal = Display.FieldValue(tmp[i + 1], fields[j], this.fields);
            if(newVal !== oldVal) {
              updatedInfo = ( updatedInfo === '' ? '' : updatedInfo + '\n') 
                + this.fields[fields[j]].label_name + ' : ' + newVal;
            }
          }
        }
        data.push([no, date, user, updatedInfo]);
      }
      resolve(data);
    }).then(data => this.setState({ ...this.state, inApiCall: false, data }) );
  }

  render() {
    if(!this.user.package || this.user.package < 2) {
      return(<h1>Not Available in current package. Please contact support</h1>);
    }
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid">
          <div className="row">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Updated Date</th>
                  <th>Updated User</th>
                  <th>Updated Info</th>
                </tr>
              </thead>
              <tbody> 
                {
                  this.state.data.length > 0
                    ? this.state.data.map((row,i) => <tr key={`history_${i}`}>{row.map((col,j) => <td key={`history_${i}_${j}`}>{col}</td>)}</tr>)
                    : <tr><td colSpan="4">No Records Found</td></tr>
                } 
              </tbody>
            </Table>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(LeadHistory);
